import React, { useState } from 'react'

import PasswordInput from './PasswordInput';
import API_URL from './ApiUrl'
import { useTranslation } from 'react-i18next';

const OAuthAuthorizeForm = ({ clientId, redirectUri, state, onAuthorized }) => {
    const { t } = useTranslation();
    const [apiresponse, setApiResponse] = useState({
        loading: false,
        success: false,
        status: '',
        error: false
    });
    const [formInput, setFormInput] = useState({
        email: "",
        password: "",
    });
    const [formError, setFormError] = useState({
        email: "",
        password: "",
        response: "",
    });

    const handleUserInput = (name, value) => {
        setFormInput({
            ...formInput,
            [name]: value,
        })
    };

    const handleSubmit = async (e) => {
        e.preventDefault();
        let inputError = {
            email: "",
            password: "",
            response: "",
        }

        let inputRespone = {
            loading: false,
            success: false,
            status: '',
            error: false
        }
        setApiResponse({
            ...inputRespone
        });
        if (!formInput.email) {
            setFormError({
                ...inputError,
                email: t('oauth.form.error.empty_email'),
            })
            return;
        }
        if (!/^[\w-.]+@([\w-]+\.)+[\w-]{2,4}$/.test(formInput.email)) {
            setFormError({
                ...inputError,
                email: t('oauth.form.error.email_format'),
            })
            return;
        }
        if (!formInput.password) {
            setFormError({
                ...inputError,
                password: t('oauth.form.error.empty_password'),
            })
            return;
        }
        setFormError(inputError);

        setApiResponse({
            ...apiresponse,
            loading: true
        });
        await fetch(`${API_URL}/oauth/authorize`, {
            body: JSON.stringify({
                email: formInput.email,
                password: formInput.password,
                client_id: clientId,
                redirect_uri: redirectUri,
                state: state,
            }),
            method: 'POST',
            headers: {
                'Content-Type': 'application/json'
            }
        })
            .then(async function (response) {
                console.log(response);
                setApiResponse({
                    loading: false,
                    success: response.ok,
                    status: response.status,
                    error: response.status !== 200 ? true : false
                });
                if (response.ok) {
                    const data = await response.json();
                    onAuthorized(data.redirect_url);
                } else {
                    switch (response.status) {
                        case 401:
                            setFormError({
                                ...inputError,
                                response: t('oauth.form.error.invalid_credentials')
                            })
                            break;
                        case 403:
                            setFormError({
                                ...inputError,
                                response: t('oauth.form.error.not_verified')
                            })
                            break;
                        case 400:
                            setFormError({
                                ...inputError,
                                response: t('oauth.form.error.bad_request')
                            })
                            break;
                        default:
                            setFormError({
                                ...inputError,
                                response: t('oauth.form.error.api_other') + response.status
                            })
                            break;
                    }
                }
            })
            .catch(function (error) {
                console.log(error);
                setApiResponse({
                    error: true,
                    loading: false,
                    status: error
                });
            });

    }

    return (
        <form onSubmit={handleSubmit} className='form'>
            <p className="label">{t('oauth.form.email.title')}</p>
            <input name="email"
                type="email"
                onChange={({ target }) => handleUserInput(target.name, target.value)}
                value={formInput.email}
                placeholder={t('oauth.form.email.placeholder')}
            />
            <p className="error-message">{formError.email}</p>

            <p className="label">{t('oauth.form.password.title')}</p>
            <PasswordInput name="password"
                type="password"
                onChange={({ target }) => handleUserInput(target.name, target.value)}
                value={formInput.password}
                placeholder={t('oauth.form.password.placeholder')}
            />
            <p className="error-message">{formError.password}</p>
            <p className="error-message">{formError.response}</p>
            <input className='submit' type="submit" value={t('oauth.form.btn')} disabled={apiresponse.loading || apiresponse.success} />
        </form>
    )
}

export default OAuthAuthorizeForm;